import { Form } from "antd"
import { Group, Title } from "components/common"
import { t } from "i18next"
import PaymentProofImageUpload from "../../paymentProofImageUpload"
import RACheckbox from "./RACheckbox"
import AccountantSection from "./AccountantSection"
import { useEffect } from "react"
import { fieldMapper } from "features/leads/components/addSalesModal/utils"

const ExtraFieldsSection = ({
  paymentModesMap,
  form,
  getAccountant,
  accountantData,
  isLoadingAccountant,
  platformKey,
  projectId,
  ocrEnabled,
  attachmentType,
  imageData,
  isRaEnabled,
}) => {
  const depositSlip = Form.useWatch("bank_deposit_slip", form)
  const enableDepositRA = Form.useWatch("enableDepositRA", form)
  const extraFields = paymentModesMap?.[attachmentType]?.extraFields

  useEffect(() => {
    if (depositSlip) {
      depositSlip?.imageData?.chequeType && form.setFieldsValue({ paymentType: depositSlip?.imageData?.chequeType })
      const depositSlipField =
        ["cheque", "cash", "bank_order"].includes(attachmentType) &&
        paymentModesMap?.[attachmentType]?.meta?.depositSlip
      fieldMapper(depositSlip?.imageData, depositSlipField, form)
    }
  }, [depositSlip, attachmentType])

  const hasBankDepositSlip = extraFields?.["bank_deposit_slip"]
  const hasReceipt = extraFields?.["receipt"]

  if (!hasBankDepositSlip && !hasReceipt) return null

  return (
    <>
      <Title type="secondary" level={4}>
        {hasBankDepositSlip ? t("Bank Deposit Slip Details") : t("Receipt Details")}
      </Title>
      {!!isRaEnabled && hasBankDepositSlip && !depositSlip?.fileList?.length && (
        <RACheckbox form={form} fieldName="enableDepositRA" value={enableDepositRA} getAccountant={getAccountant} />
      )}

      {!!enableDepositRA ? (
        <AccountantSection
          form={form}
          accountantData={accountantData}
          isLoadingAccountant={isLoadingAccountant}
          platformKey={platformKey}
          projectId={projectId}
        />
      ) : (
        <Group template="repeat(2, 1fr)" gap="6px 32px">
          {!!hasBankDepositSlip && (
            <Form.Item
              name="bank_deposit_slip"
              label={t("Bank Deposit Slip")}
              required
              rules={[
                {
                  validator: (_, value) =>
                    !value || !value?.fileList?.length
                      ? Promise.reject(t("Bank Deposit Slip is Required"))
                      : Promise.resolve(),
                },
              ]}
            >
              <PaymentProofImageUpload
                setFiles={data => form.setFieldsValue({ bank_deposit_slip: data })}
                paymentProofProps={{
                  attachmentTypeId: hasBankDepositSlip?.attachmentTypeId,
                  api: ocrEnabled,
                  visionAllowedonProject: !!ocrEnabled,
                  detectPaymentMode: false,
                  date: imageData?.imageData?.date,
                }}
                platformKey={platformKey}
                projectId={projectId}
              />
            </Form.Item>
          )}
          {!!hasReceipt && (
            <Form.Item
              name="receipt"
              label={t("Receipt")}
              required={hasReceipt?.mandatory}
              rules={[
                {
                  validator: (_, value) =>
                    hasReceipt?.mandatory && (!value || !value?.length)
                      ? Promise.reject(t("Receipt is Required"))
                      : Promise.resolve(),
                },
              ]}
            >
              <PaymentProofImageUpload
                setFiles={data => form.setFieldsValue({ receipt: data })}
                paymentProofProps={{
                  attachmentTypeId: hasReceipt?.attachmentTypeId,
                  api: false,
                  visionAllowedonProject: false,
                  detectPaymentMode: false,
                }}
                platformKey={platformKey}
                projectId={projectId}
              />
            </Form.Item>
          )}
        </Group>
      )}
    </>
  )
}

export default ExtraFieldsSection
